import React from 'react'

function ChooseFWPI() {
    const tagList = [
        "Get Certified & Verified as a True Professional",
        "Accredit Your Academy or Become a Training Partner",
        "Certify Your Gym or Studio with Facility Recognition",
        "Be Celebrated through FWPI Awards & Recognition",
        "Lead with Ethics, Authenticity, and Responsibility",
    ]
    return (
        <section className="w-full bg-gradient-radial py-12 lg:py-15">
            <div className="container mx-auto px-4 lg:px-15 flex flex-col lg:flex-row items-center justify-between gap-8">
                <div className="w-full lg:w-full flex flex-col items-start gap-6">
                    <h2 className="text-2xl sm:text-3xl lg:text-5xl font-bold font-urbanist text-white text-center sm:text-left">
                        Why Choose FWPI
                    </h2>
                    {
                        tagList.map((tagline, index) => {
                            return (
                                <div className="flex items-start gap-6 mt-5" key={index} >
                                    <img className="w-6 h-6 lg:w-7 lg:h-7 flex-shrink-0 rounded-full" src="/assets/check-list.png" alt={tagline} />
                                    <p className="text-neutral-200 text-lg sm:text-xl lg:text-2xl font-semibold font-poppins">
                                        {tagline}
                                    </p>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </section>
    )
}

export default ChooseFWPI